// src/app/app.config.server.ts

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  ApplicationConfig,
  provideClientHydration,
} from "@angular/platform-browser";
import { provideServerRendering } from "@angular/platform-server";
import { provideRouter, Routes, withEnabledBlockingInitialNavigation } from "@angular/router";
import { mainAppRoutes } from "./app.routes";
import { AppInterceptor } from "./core/interceptors/apiUrl.interceptor";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
  FacebookLoginProvider,
  GoogleLoginProvider,
  SocialAuthServiceConfig,
} from "@abacritt/angularx-social-login";
import { Social_Providers } from "./lookup-config";
import { AuthGuard } from "./guards/auth-guard.service";

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: "SocialAuthServiceConfig",
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              Social_Providers.find((x) => x.provider == "google")?.value || '',
              {
                oneTapEnabled: false,
              }
            ),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(
              Social_Providers.find((x) => x.provider == "facebook")?.value || ''
            ),
          },
        ],
        onError: (err) => console.error(err),
      } as SocialAuthServiceConfig,
    },
    provideServerRendering(),
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true,
    },
    // provideRouter(routes)
    // Add any server-only providers here
    provideRouter(mainAppRoutes, withEnabledBlockingInitialNavigation()),
    // provideClientHydration(),
    AuthGuard
    // provideHttpClient(withFetch()),
  ],
};
